var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3358",
    "data-name": "Group 3358",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.533,
    height: 46.134,
    viewBox: "0 0 31.533 46.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M25,35.931a21.81,21.81,0,0,0-3.6-.916c.841-.988,1.738-2.084,2.639-3.255,4.969-6.459,7.488-11.841,7.488-15.992A15.766,15.766,0,1,0,0,15.767C0,19.942,2.52,25.33,7.488,31.78c.9,1.164,1.789,2.253,2.628,3.236a21.814,21.814,0,0,0-3.587.914c-3.749,1.34-4.536,3.137-4.536,4.412s.787,3.072,4.536,4.411a28.464,28.464,0,0,0,9.238,1.379A28.464,28.464,0,0,0,25,44.754c3.749-1.339,4.536-3.137,4.536-4.411S28.754,37.27,25,35.931ZM2.7,15.767a13.064,13.064,0,0,1,26.127,0c0,3.487-2.389,8.438-6.908,14.319a88.156,88.156,0,0,1-6.158,7.135A87.441,87.441,0,0,1,9.63,30.132C5.1,24.249,2.7,19.284,2.7,15.767ZM24.1,42.208a25.748,25.748,0,0,1-8.33,1.222,25.742,25.742,0,0,1-8.329-1.222C5.444,41.5,4.7,40.69,4.7,40.343s.747-1.152,2.741-1.867a21.565,21.565,0,0,1,4.824-1.034c1.468,1.6,2.484,2.6,2.562,2.676l.946.923.943-.923c.078-.077,1.09-1.07,2.553-2.676A21.57,21.57,0,0,1,24.1,38.476c2,.714,2.741,1.523,2.741,1.867S26.093,41.5,24.1,42.208Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M106.528,91.667a1.083,1.083,0,0,0-2.057.664,6.712,6.712,0,1,1-4.579-4.4,1.083,1.083,0,1,0,.581-2.086,8.877,8.877,0,1,0,6.062,5.824Z",
    transform: "translate(-82.296 -78.29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M213.258,107.289l-.01-.01a1.083,1.083,0,0,0-1.526,1.531l.01.01a1.082,1.082,0,1,0,1.531-1.531Z",
    transform: "translate(-192.144 -97.203)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdi);
export default __webpack_public_path__ + "static/media/PDI.b295a1758d8b5a1c3a2b72cecf76d076.svg";
export { ForwardRef as ReactComponent };